import { ITaskSearch } from '@/Models/SearchParams/ITaskSearch';
import { defineStore } from 'pinia';

export const useTaskSearchStore = defineStore('taskSearch', {
    state: () => {
        return {
            taskSearch: {participantFirstName: "", participantLastName: "", workflowType: null, workflowTypeStatus: null} as ITaskSearch,
        };
    },
})